const carFinder = () => {
  const NAMESPACE = 'whichcar/v1';
  const REST_BASE = 'car-finder';
  const REST_BASE_PATH = `/wp-json/${NAMESPACE}/${REST_BASE}`;
  const form = document.querySelector('#car-finder-form');
  
  /**
   *
   * @param callback
   */
  function readyMMS(callback) {
    // in case the document is already rendered
    if (document.readyState !== 'loading') {
      callback();
    }// modern browsers
    else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', callback);
    }// IE <= 8
    else {
      document.attachEvent('onreadystatechange', function () {
        if (document.readyState === 'complete') {
          callback();
        }
      });
    }
  }
  
  /**
   * Getting Models for given Make selection...
   *
   * @param {string} make
   * @returns {Promise<any>}
   */
  async function getModels(make) {
    const nonce = form.elements._wpnonce.value;
    let response = await fetch(`${REST_BASE_PATH}/get-models/${make}/?_wpnonce=${nonce}`);
    return await response.json(); // Returns it as Promise
  }
  
  /**
   *
   * @param {Element} selectElement
   */
  function removeMakeModelOptions(selectElement) {
    var i, L = selectElement.options.length;
    for (i = L; i > 0; i--) {
      selectElement.remove(i);
    }
  }
  
  /**
   *
   * @param {array}  data
   * @param {Element} target
   */
  function copyOptionsToSelect(data, target) {
    removeMakeModelOptions(target);
    
    data.forEach((make) => {
      const option = document.createElement('option');
      option.value = make.id;
      option.text = make.name;
      target.appendChild(option);
    })
    
  }
  
  /**
   *
   * @param make
   * @returns {Promise<void>}
   */
  async function fetchModels(make) {
    await getModels(make).then((response) => {
      if (response.success) {
        const modelsSelect = document.querySelector('#models-list');
        copyOptionsToSelect(response.data, modelsSelect);
        modelsSelect.options[0].hidden = false;
        modelsSelect.options[0].disabled = false;
        modelsSelect.disabled = false;
      }
    });
  }
  
  async function findCar() {
    let response = await fetch(`${REST_BASE_PATH}/find-car/`, {
      method: 'POST',
      body: new FormData(form),
    });
    return await response.json();
  }
  
  if (form) {
    readyMMS(function () {
      const makesSelect = form.querySelector('#makes-list');
      const modelsSelect = form.querySelector('#models-list');
      
      makesSelect.addEventListener('change', (evt) => {
        modelsSelect.disabled = true;
        fetchModels(evt.target.value);
      })
    });
    
    form.addEventListener('submit', async (evt) => {
      evt.preventDefault();
      form.querySelector('button[type="submit"]').disabled = true;
      await findCar().then((response) => {
        if (response.success && response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
        } else {
          console.error('Failed to find Make/Model');
          form.querySelector('button[type="submit"]').disabled = false;
        }
      });
    });
  }
}

export {carFinder};
